module.exports = __webpack_public_path__ + "img/态势管理.851ea6c0.png";